<template>
    <div class="ticket-header" v-if="$isApp === 'h5'">
        <div class="header-main">
            <div class="header-logo-and-more">
                <div v-if="!$route.query.amid && !$route.query.m" class="header-more" @click="openMark">
                    <!-- <i class="iconfont">&#xe6c5;</i> -->
                    <!-- <img src="@/assets/image/navigationMenu.png"> -->
                </div>
                <div class="header-logo cssicon"></div>
            </div>
            <div class="open-app" v-if="!$route.query.amid && !$route.query.m && !$route.query.own_id && $route.name !== 'MallYunNan'">
                <div class="open-text">推荐使用摩登天空官方平台“正在现场”</div>
                <div class="open-btn" @click="toApp">在「正在现场APP」中打开</div>
            </div>
        </div>
        <div class="mask" v-if="mask" :data-state="true" @click="close">
            <div class="user-menu">
                <div class="menu-logo cssicon"></div>
                <div class="user-menu-main">
                    <div class="menu-user-info">
                        <div class="user-info-headshot">
                            <img v-if="headshot" :src="headshot">
                            <img v-else src="https://img.zhengzai.tv/user/2021/07/27/a4cc2a4e6dcd44d1812dc60e079086b4.png">
                        </div>
                        <div v-if="nickname" class="user-info-name" @click="toLogin">{{nickname}} <span v-if="isVip"><img src="https://img.zhengzai.tv/files/2020/08/28/5f490418d30b4.png"/></span></div>
                        <div v-else class="user-info-name" @click="toLogin">未登录</div>
                    </div>
                    <div class="menu-main-list">
                        <div :class="'main-list-content ' + (activeTag === item.tag ? 'menu-active' : '')" v-for="item in mainMenuList" :key="item.tag" @click="jumpTo(item.tag)">
                            <div class="list-content">
                                <span class="list-content-icon"><i class="iconfont" v-html="item.icon"></i></span>
                                <span class="list-content-title">{{item.title}}</span>
                            </div>
                            <span v-if="item.arrow" class="list-content-more iconfont">&#xe651;</span>
                        </div>
                        <div v-if="nickname" class="main-list-content" @click="logout">
                            <div class="list-content">
                                <span class="list-content-icon"><i class="iconfont">&#xe698;</i></span>
                                <span class="list-content-title">退出登录</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loading :loading="loading" />
    </div>
</template>

<script>
import host from '@/utils/hostName.js';
import browser from '@/utils/browser';
require('@/assets/css/header/ticketHeader.scss');

export default {
    name: 'TicketHeader',
    data () {
        return {
            mask: false,
            isLogin: false,
            nickname: '',
            headshot: '',
            mainMenuList: [
                {
                    title: '摩登天空会员',
                    tag: 'user',
                    icon: '&#xe629;',
                    arrow: true
                },
                // {
                //     title: '明日之子',
                //     tag: 'chaojiyiban',
                //     icon: '&#xe68f;',
                //     arrow: true
                // },
                {
                    title: '演出',
                    tag: 'ticket',
                    icon: '&#xe6fe;',
                    arrow: true
                },
                {
                    title: '商城',
                    tag: 'goods',
                    // tag: 'mall',
                    icon: '&#xe642;',
                    arrow: true
                },
                // {
                //     title: '商城',
                //     tag: 'mall',
                //     icon: '&#xe642;',
                //     arrow: true
                // },
                // {
                //     title: '视频',
                //     tag: 'media',
                //     icon: '&#xe641;',
                //     arrow: true
                // },
                {
                    title: '观演人',
                    tag: 'enter',
                    icon: '&#xe694;',
                    arrow: true
                },
                {
                    title: '我的订单',
                    tag: 'order',
                    icon: '&#xe693;',
                    arrow: true
                },
                {
                    title: '我的地址',
                    tag: 'address',
                    icon: '&#xe692;',
                    arrow: true
                },
                {
                    title: '积分商城',
                    tag: 'integral',
                    icon: '&#xe65e;',
                    arrow: true
                }
            ],
            loading: false,
            activeTag: 'ticket',
            isVip: null
        };
    },
    created () {
        if (this.$cookie.get('stageMarker')) {
            let isVip = JSON.parse(this.$cookie.get('stageMarker'));
            if (isVip === 10 || isVip === 11) {
                this.isVip = 1;
            }
        }
        console.log(this.$route.path.split('/')[1])
        if (this.$route.path.split('/')[1] === 'refund') {
            this.activeTag = 'order';
        } else if (this.$route.path.split('/')[1] === 'nowBuy') {
            this.activeTag = 'order';
        } else if(this.$route.path.split('/')[1] === 'nft'){
            this.activeTag = 'order';
        }else if(this.$route.path.split('/')[1] === 'newNowBuy'){
            this.activeTag = 'order';
        }else{
            this.activeTag = this.$route.path.split('/')[1];
        }
        let token = this.$cookie.get('cookie_user_auth');
        this.isLogin = Boolean(token);
        if (this.isLogin) {
            this.headshot = this.$cookie.get('headshot');
            this.nickname = this.$cookie.get('nickname');
        }
    },
    mounted () {
        window._czc = window._czc || [];
    },
    methods: {
        openMark () {
            let route = this.$route.name;
            let isAndroid = this.$browser.versions().android;
            if (isAndroid && route === 'pgcvideo') {
                this.$emit('hide');
            }
            if (!this.$route.query.signature) {
                this.mask = true;
                this.$scroll.PreventAll();
            }
        },
        // 关闭蒙板
        close (e) {
            let route = this.$route.name;
            let isAndroid = this.$browser.versions().android;
            if (isAndroid && route === 'pgcvideo') {
                this.$emit('show');
            }
            let state = e.target.dataset.state;
            if (state) {
                this.mask = false;
                this.$scroll.RemovePrevent();
            }
        },
        jumpTo (to) {
            console.log(to, 'to')
            switch (to) {
            case 'user':
                this.$router.push({
                    path: '/user/vip'
                });
                break;
            case 'ticket':
                this.toTicketHome();
                break;
            case 'goods':
            // case 'mall':
                this.toMallHome();
                break;
            case 'media':
                this.toMediaHome();
                break;
            case 'enter':
                this.toEnter();
                break;
            case 'order':
                this.toOrder();
                break;
            case 'address':
                this.toAddress();
                break;
            case 'integral':
                this.toIntegral();
                break;
            case 'logout':
                this.logout();
                break;
            case 'chaojiyiban':
                this.WJJW();
                break;
            default:
                break;
            }
        },
        toTicketHome () {
            if (!this.$route.query.signature) {
                this.$router.push({path: '/ticket/home'});
            }
        },
        toMallHome () {
            if (!this.$route.query.signature) {
                this.$router.push({path: '/goods/home'});
            }
        },
        toMediaHome () {
            if (!this.$route.query.signature) {
                this.$router.push({path: '/media/home'});
            }
        },
        toLogin () {
            if (this.isLogin) {
                this.$router.push({
                    path: '/user/userinfo'
                });
            } else {
                this.$router.push({
                    path: '/user'
                });
            }
        },
        toEnter () {
            window._czc.push(['_trackEvent', '个人中心', 'PERSONAL_CENTER_BTN_ADMISSION_EVENT', '100201']);
            this.$TD.event('center_click_enter');
            if (this.$route.query.signature) {
                let query = this.$route.query;
                query.from = 'header';
                this.$router.push({
                    path: '/v1/entrants',
                    name: 'EntrantsList',
                    // path: '/enter/list',
                    // name: 'SelectEnter',
                    query: query
                });
            } else {
                this.$router.push({
                    path: '/v1/entrants',
                    name: 'EntrantsList',
                    // path: '/enter/list',
                    // name: 'SelectEnter',
                    query: {
                        from: 'header'
                    }
                });
            }
        },
        toOrder () {
            window._czc.push(['_trackEvent', '个人中心', 'PERSONAL_CENTER_BTN_ORDER_EVENT', '100190']);
            this.$TD.event('center_click_order');
            if (!this.$route.query.signature) {
                let query = this.$route.query;
                query.from = 'header';
                this.$router.push({
                    path: '/order/list',
                    name: 'OrderList',
                    query: query
                });
            }
        },
        logout () {
            this.loading = true;
            this.nickname = '';
            this.headshot = '';
            this.mask = false;
            this.$cookie.remove('cookie_user_auth');
            this.$cookie.remove('headshot');
            this.$cookie.remove('userid');
            this.$cookie.remove('nickname');
            this.$cookie.remove('zhengzaiOpenId');
            this.$cookie.remove('stageMarker');
            this.$cookie.remove('stageMarkerH5');
            this.$cookie.remove('club');
            this.$cookie.remove('can_be_vip');
            this.$cookie.remove('rni');
            this.$cookie.set('redirect', this.$route.fullPath, {expires: 1, path: '/'});
            this.isLogin = false;
            // this.$router.replace(this.$route.fullPath);
            if (this.$browser.versions().weixin) {
                const AppId = 'wx3498304dda39c5a1';
                let redirectUrl = host.BaseUrl('/user');
                window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + AppId + '&redirect_uri=' + encodeURIComponent(redirectUrl) + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
            } else {
                window.location.href = host.BaseUrl('/user');
            }
            this.loading = false;
            // window.location.reload();
        },
        toAddress () {
            window._czc.push(['_trackEvent', '个人中心', 'PERSONAL_CENTER_BTN_ADDRESS_EVENT', '100202']);
            this.$TD.event('center_click_address');
            if (!this.$route.query.signature) {
                let query = this.$route.query;
                query.from = 'header';
                this.$router.push({
                    path: '/address/list',
                    name: 'SelectAddress',
                    query: query
                });
            }
        },
        toIntegral () {
            window._czc.push(['_trackEvent', '个人中心', 'PERSONAL_CENTER_BTN_ADDRESS_EVENT', '100202']);
            this.$TD.event('center_click_address');
            if (!this.$route.query.signature) {
                let query = this.$route.query;
                query.from = 'header';
                this.$router.push({
                    path: '/integral/home',
                    name: 'integralHome',
                    query: query
                });
            }
        },
        WJJW () {
            this.$router.push({
                path: '/chaojiyiban',
                name: 'ForWJJW'
            });
        },
        toApp () {
            let jumpHref = 'zztv://';
            let business = this.$route.path.split('/')[1];
            console.log(business, '??????')
            let id = '';
            let type = '';
            switch (business) {
            case 'ticket':
                if (this.$route.name === 'TourList') { // 特殊处理，跳转app不同页面，为保障左边菜单栏‘票务’高亮,巡演列表归在票务的路由下
                    type = 'tour/';
                    id = this.$route.query.id ? this.$route.query.id : '';
                } else {
                    type = 'ticket/';
                    id = this.$route.query.id ? this.$route.query.id : this.$route.query.performance_id ? this.$route.query.performance_id : '';
                }
                break;
            case 'goods':
                type = 'goods/';
                id = this.$route.query.id ? this.$route.query.id : '';
                break;
            // case 'tour':
            //     type = 'tour';
            //     id = this.$route.query.id ? this.$route.query.id : '';
            //     break;
            // case 'order':
            //     type = 'live/pgc';
            //     id = this.$route.query.id ? this.$route.query.id : '';
            //     break;
            // case 'address':
            //     type = 'video/pgc';
            //     id = this.$route.query.id ? this.$route.query.id : '';
            //     break;
            default:
                type = '';
                id = '';
                break;
            }
            jumpHref = 'zztv://' + type + id;
            let browser = this.$browser.versions();
            let isWX = browser.weixin;
            let isIos = browser.ios;
            let isAndroid = browser.android;
            let that = this;
            function openAPP () {
                if (isIos) {
                    window.location.href = jumpHref;
                    setTimeout(function () {
                        that.$router.push({
                            path: '/download'
                        });
                    }, 1500);
                    // setTimeout(function () {
                    //     location.reload();
                    // }, 1100);
                } else if (isAndroid) {
                    jumpHref = id ? jumpHref : 'zztv://';
                    window.location.href = jumpHref;
                    setTimeout(function () {
                        that.$router.push({
                            path: '/download'
                        });
                    }, 1500);
                }
            }
            if (isWX) {
                if (isIos) {
                    window.location.href = 'itms-apps://itunes.apple.com/us/app/正在现场/id979095986?l=zh&ls=1&mt=8';
                } else if (isAndroid) {
                    window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.modernsky.istv';
                } else {
                    let message = '请打开「正在现场APP」!';
                    this.$dialog(message);
                }
            } else {
                openAPP();
            }
        }
    }
};
</script>
